export default "__VITE_ASSET__Bely1$43__"